import type { RfqDeclineReason } from "../types";

export interface DeclineReason {
  code: RfqDeclineReason;
  label: string;
}

export const DECLINE_REASONS: DeclineReason[] = [
  { code: "CAPACITY_FULL", label: "No capacity" },
  { code: "RATE_NOT_VIABLE", label: "Rate not viable" },
  { code: "LOCATION_NOT_SERVICEABLE", label: "Location not serviceable" },
  { code: "SCOPE_MISMATCH", label: "Scope mismatch" },
  { code: "TIMELINE_NOT_FEASIBLE", label: "Timeline not feasible" },
  { code: "OTHER", label: "Other" },
];

export function declineReasonLabel(code?: string | null): string {
  if (!code) return "";
  return DECLINE_REASONS.find((reason) => reason.code === code)?.label ?? code;
}
